<template>
  <div>
    <el-dialog
      ref="addDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h450_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddForm"
        :model="dialogAddForm"
        :rules="dialogAddFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="报告类型"
                  prop="type"
                >
                  <el-select
                    v-model="dialogAddForm.type"
                    filterable
                    clearable
                    placeholder="请选择报告类型"
                    style="width:100%"
                    @change="handleTypeChange"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属省区"
                  prop="provinceId"
                >
                  <el-select
                    v-model="dialogAddForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="报告周期"
                  prop="periodId"
                >
                  <el-select
                    v-model="dialogAddForm.periodId"
                    filterable
                    clearable
                    placeholder="请选择报告周期"
                    style="width:100%"
                    @change="handlePeriodChange"
                  >
                    <el-option
                      v-for="item in periodOptions"
                      :key="'Period_' + item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                      <span style="float: left">{{ item.name }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.startDate }} 至 {{ item.endDate }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-form-item
                label="市场"
                prop="cityIdArray"
              >
                <el-checkbox-group
                  v-model="dialogAddForm.cityIdArray"
                  size="small"
                >
                  <el-col
                    v-for="(item, index) in cityDataList"
                    :key="'City_' + index"
                    :span="4"
                  >
                    <el-checkbox-button
                      :label="item.id"
                      :disabled="item.disabled"
                      style="width: 100%;"
                    >
                      {{ item.name }}
                    </el-checkbox-button>
                  </el-col>
                </el-checkbox-group>
              </el-form-item>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { listAreaApi } from '@/api/v2/area';
import { listMarketReportPeriodApi } from '@/api/v2/marketReportPeriod';
import { listExistMarketReportApi, saveMarketReportApi } from '@/api/v2/marketReport';

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogAddForm: {},
      dialogAddFormRules: {
        type: [{ required: true, message: '请选择报告类型', trigger: 'change' }],
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        periodId: [{ required: true, message: '请选择报告周期', trigger: 'change' }],
        cityIdArray: [{ required: true, message: '请选择要生成报告的市场', trigger: 'change' }],
      },
      typeOptions: [{ value: 1, label: '周报' }, { value: 2, label: '月报' }, { value: 3, label: '年报' }],
      provinceOptions: [],
      periodOptions: [],
      cityDataList: [],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this

        _this.dialogAddForm = {
          type: null,
          provinceId: null,
          periodId: '',
          cityIdArray: [],
        }
        _this.periodOptions = [];
        _this.cityDataList = [];

        // 获取省区选项数据
        _this.loadProvinceData()

        _this.$nextTick(() => {
          _this.$refs.dialogAddForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 获取省区下拉数据
    loadProvinceData() {
      let _this = this;
      _this.provinceOptions = [];
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.provinceOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 选择报告类型回调
    handleTypeChange(val) {
      let _this = this;
      _this.periodOptions = [];
      _this.dialogAddForm.periodId = '';
      if (val) {
        _this.loadPeriodData();
      }
    },
    // 选择省区回调
    handleProvinceChange(val) {
      let _this = this;
      _this.cityDataList = [];
      _this.periodOptions = [];
      _this.dialogAddForm.cityIdArray = [];
      _this.dialogAddForm.periodId = '';
      if (val) {
        _this.loadCityData(val);
        _this.loadPeriodData();
      }
    },
    // 获取城市选项数据
    loadCityData(provinceId) {
      let _this = this;
      listAreaApi({ parentId: provinceId, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.cityDataList.push({ name: item.name, id: item.id, disabled: false })
        })
      })
    },
    // 获取报告周期数据集合
    loadPeriodData() {
      let _this = this;
      if (_this.dialogAddForm.type && _this.dialogAddForm.provinceId) {
        listMarketReportPeriodApi({ provinceId: _this.dialogAddForm.provinceId, type: _this.dialogAddForm.type }).then((response) => {
          const { data } = response;
          _this.periodOptions = data || [];
        })
      }
    },
    // 选择报告周期回调
    handlePeriodChange(val) {
      let _this = this;
      _this.dialogAddForm.cityIdArray = [];
      if (val) {
        listExistMarketReportApi({ provinceId: _this.dialogAddForm.provinceId, periodId: val }).then((response) => {
          const { data } = response;
          let existCityArray = [];
          if (data) {
            data.forEach(item => {
              existCityArray.push(item.cityId)
            })
          }
          _this.cityDataList.forEach(item => {
            item.disabled = existCityArray.includes(item.id)
          })
        })
      }
    },

    // 新增保存
    handleSave() {
      let _this = this
      _this.$refs.dialogAddForm.validate(valid => {
        if (valid) {
          _this.$confirm('是否确定创建市场周报', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            saveMarketReportApi(_this.dialogAddForm).then(() => {
              _this.$message({ message: '创建市场周报成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    modalClose() {
      let _this = this
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-checkbox-group {
  .el-col {
    min-height: 28px;
    padding: 5px;
  }
}

::v-deep .el-checkbox-button__inner {
  width: 100%;
}
</style>
